'use strict';
import utils from "./utils/utils.js";
import axios from "axios";

((w, d) => {

    const trueTypeOf = (obj) => {
        return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    };

    const getRealtimeRest = () => {
        const campaignDate = d.getElementById("campaignDate").dataset.datetime,
            //campaignTimestamp = new Date(campaignDate + "T00:00:00").getTime(),
            campaignTimestamp = new Date(campaignDate + "T23:59:59").getTime(),
            diff = (campaignTimestamp - new Date().getTime()) / 1000,
            days_div = 60 * 60 * 24,
            hours_div = 60 * 60,
            days = diff > 0 ? Math.floor(diff / days_div) : 0,
            hours = diff > 0 ? Math.floor((diff % days_div) / hours_div) : 0,
            minutes = diff > 0 ? Math.floor(((diff % days_div) % hours_div) / 60) : 0,
            seconds = diff > 0 ? Math.floor(((diff % days_div) % hours_div) % 60) : 0;
        return {
            days: utils.formatNum2Str(days),
            hours: utils.formatNum2Str(hours, "00"),
            minutes: utils.formatNum2Str(minutes, "00"),
            seconds: utils.formatNum2Str(seconds, "00")
        }
    }

    const campaignRest = trueTypeOf(d.getElementById("campaignDate")) !== 'null' ? new Vue({
        el: "#Vue_BalletCampaignRest",
        data: {
            days: getRealtimeRest().days,
            hours: getRealtimeRest().hours,
            minutes: getRealtimeRest().minutes,
            seconds: getRealtimeRest().seconds
        },
        mounted() {
            setInterval(() => {
                this.days = getRealtimeRest().days,
                    this.hours = getRealtimeRest().hours,
                    this.minutes = getRealtimeRest().minutes,
                    this.seconds = getRealtimeRest().seconds;
            }, 1000);
        }
    }) : 'null';
    
    const regionCode = utils.DEFAULT_STUDIO_REAGION;
    const studioList = new Vue({
        el: "#Vue_BalletStudioList",
        data: function () {
            return {
                BALLET_PATH: utils.BALLET_PATH,
                ASSETS_PATH: utils.ASSETS_PATH,
                isActive: regionCode,
                isFadein: false,
                isSsrHidden: false,
                region_name: "",
                region_code: regionCode,
                regionItems: [],
                studioItems: []
            }
        },
        created() {
            this.switchRegion(regionCode);
        },
        methods: {
            switchRegion: function (region_code, ev) {
                this.isActive = region_code;
                this.isFadein = false
                this.region_code = region_code;
                const self = this;
                axios
                    .get(utils.BALLET_PATH + "/api/region/?region=" + this.region_code)
                    .then((res) => {
                        self.regionItems = res.data;
                    })
                axios
                    .get(utils.BALLET_PATH + "/api/studio/?region=" + this.region_code)
                    .then((res) => {
                        self.studioItems = res.data;
                        self.isSsrHidden = true;
                        self.isFadein = true;
                    })
                if (ev) {
                    ev.preventDefault();
                } else {
                    return false;
                }
            }
        },
        filters: {
            "br": function (str) {
                return str.replace(/\//g, "<br>");
            }
        }
    });
})(window, document);